import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BookLD } from 'src/app/models/book-ld';
import { Record } from '../models/record';

@Injectable({
  providedIn: 'root',
})
export class JsonLDService {
  static scriptType = 'application/ld+json';
  static bookSchema = (book?: BookLD) => {
    return {
      '@context': 'http://schema.org',
      '@type': 'Book',
      '@id': book.urlRecurso,
      abstract: book.description,
      isbn: book.isbn,
      url: book.urlRecurso,
      mainEntityOfPage: book.urlRecurso,
      image: book.cover,
      name: book.title,
      author: {
        '@type': 'Person',
        name: book.author,
      },
      bookFormat: {
        '@type': book.bookFormat,
      },
    };
  };

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  removeStructuredData(): void {
    const els = [];
    ['structured-data', 'structured-data-org'].forEach((c) => {
      els.push(...Array.from(this._document.head.getElementsByClassName(c)));
    });
    els.forEach((el) => this._document.head.removeChild(el));
  }

  insertSchema(schema: any, className = 'structured-data'): void {
    let script;
    let shouldAppend = false;
    if (this._document.head.getElementsByClassName(className).length) {
      script = this._document.head.getElementsByClassName(className)[0];
    } else {
      script = this._document.createElement('script');
      shouldAppend = true;
    }
    script.setAttribute('class', className);
    script.type = JsonLDService.scriptType;
    script.text = JSON.stringify(schema);
    if (shouldAppend) {
      this._document.head.appendChild(script);
    }
  }

  insertBookLD(record: Record, newDescription: string) {
    const bookLD = new BookLD();
    bookLD.title = record.title;
    bookLD.author = record.author;
    bookLD.cover = record.coverImageUrl;
    bookLD.description = newDescription;
    bookLD.isbn = record.isbn;

    if (record.formats.includes('MP3')) {
      bookLD.bookFormat = 'AudiobookFormat';
    } else {
      bookLD.bookFormat = 'EBook';
    }
    bookLD.urlRecurso = window.location.href;

    this.insertSchema(JsonLDService.bookSchema(bookLD));

    return bookLD;
  }
}
